import type { Testimonial } from "../types/product";

export const testimonials: Testimonial[] = [
  {
    quote: "Grown has helped me feel more confident and alive. I've seen noticeable improvements in just a few weeks.",
    name: "Natasha Nerja",
    product: "Seven Sins Grown",
  },
  {
    quote:
      "Seven Sins Boost me dio la energía que necesitaba para afrontar mis días ocupados. ¡Nunca me había sentido tan concentrado y lleno de energía!",
    name: "Sarah Argüelles",
    product: "Seven Sins Boost",
  },
  {
    quote: "Seven Sins Lust transformó completamente mi vida íntima. ¡Lo recomiendo mucho!",
    name: "Antonio Marbella",
    product: "Seven Sins Lust",
  },
  {
    quote:
      "No solo los productos son increíbles, sino que el servicio al cliente es de primera. ¡Seven Sins Master ahora es mi elección preferida!",
    name: "Carlos Madrid",
    product: "Seven Sins Master",
  },
  {
    quote:
      "Seven Sins Screaming is precies wat ik nodig had om de opwinding terug in mijn leven te brengen. Het is leuk, effectief, en de resultaten spreken voor zich!",
    name: "Isabella Tetuán",
    product: "Seven Sins Screaming",
  },
];
